export default "__VITE_ASSET__$TwjIdv6__"